






















import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from 'vue-property-decorator'
import { CollapseTransition } from "vue2-transitions";

@Component({components: {CollapseTransition}})
export default class FilterWings extends Vue {
    @Prop(Boolean) show!: boolean;
}
